<div class="dialog-header">
  <h2 mat-dialog-title>{{ data.fileName }}</h2>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  @if (isLoading) {
    <div class="loading-container">
      <mat-spinner diameter="48"></mat-spinner>
    </div>
  } @else if (hasError) {
    <div class="error-container">
      <mat-icon>error_outline</mat-icon>
      <span>{{ 'COMMON.FAILED_TO_LOAD' | translate }}</span>
    </div>
  } @else if (pdfBlob) {
    <ngx-extended-pdf-viewer
      [src]="pdfBlob"
      [page]="1"
      [zoom]="'page-fit'"
      [textLayer]="true"
      [handTool]="false"
      [showToolbar]="false"
      [useInlineScripts]="false"
      backgroundColor="#f5f5f5"
    ></ngx-extended-pdf-viewer>
  }
</mat-dialog-content>
